import { HugeiconsIcon } from "@hugeicons/react";
import type { FC } from "react";
import { computeVariantStyle, type GameRtpListVariant } from "../GameRtpList";
import { TabsList, TabsTrigger } from "../tabs";

type Tab = {
  variant: GameRtpListVariant;
  tabLabel: string;
};

type Props = {
  tabs: Tab[];
};

const GameRtpListGroupTabs: FC<Props> = ({ tabs }) => (
  <TabsList className="w-full bg-transparent border-border">
    {tabs.map((tab) => (
      <TabsTrigger
        key={tab.variant}
        value={tab.variant}
        className="gap-1.5 bg-transparent data-active:bg-secondary h-8"
      >
        <HugeiconsIcon
          icon={computeVariantStyle(tab.variant).headerIcon}
          className="size-4"
        />
        {tab.tabLabel}
      </TabsTrigger>
    ))}
  </TabsList>
);

export default GameRtpListGroupTabs;
